/*
* @描述: 商机列表
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-03 09:18:37
*/
<template>
    <div class="page_container">
        <el-tabs v-model="tabActiveName" class="list_page_tabs" @tab-click="handleClickTab">
            <el-tab-pane label="商机列表" name="business">
                <div v-loading="loading" class="el_tab_pane_wrap">
                    <div class="page-filter_wrap">
                        <div v-if="listMode==='table'&&selectedList.length"
                             class="page-filter_wrap_left page-filter_icons">
                            <span>已选中<i class="bold-count">{{ selectedList.length }}</i>项</span>
                            <i class="iconfont icon-guanbi_dise cursor" @click="handleRemoveCheckbox"></i>
                            <div>
                                <i class="iconfont icon-fenpei"
                                   v-auth="'project.edit'"
                                   @click="handleClickChangeThePerson(selectedList)">更换负责人</i>
                                <i class="iconfont icon-a-shenling1"
                                   v-auth="'project.edit'"
                                   @click="handleClickAddMember(selectedList)">添加成员</i>
                                <i v-auth="'project.del'" class="iconfont icon-shanchu1"
                                   @click="handleClickDelBusiness(selectedList)">删除</i>
                            </div>
                        </div>
                        <div v-else class="page-filter_wrap_left">
                            <el-select v-if="listMode==='board'"
                                       v-model="searchForm.project_group_id"
                                       placeholder="请选择"
                                       size="small"
                                       class="custom-select_180"
                                       @change="handleProjectGroupChange">
                                <el-option v-for="item in businessGroupList"
                                           :key="item.project_group_id"
                                           :label="item.name"
                                           :value="item.project_group_id">
                                </el-option>
                            </el-select>
                            <el-input v-model="searchForm.keyword"
                                      class="filter-input"
                                      ref="search_input"
                                      clearable
                                      placeholder="请输入您想搜索的内容"
                                      @clear="handleClickSearch"
                                      @blur="handleClickSearch"
                                      @keyup.enter.native="handleKeyupEnter">
                                <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                            </el-input>
                            <ListAdvancedFiltering :field_form="'projects'"
                                                   :field_list="formInfoList"
                                                   :system_fields="systemFilterFields"
                                                   @sendFilterData="getFilterData"/>
                        </div>
                        <div class="page-filter_wrap_right flex_wrap">
                            <ul class="business_list_type_list">
                                <el-tooltip content="切换为列表模式" effect="dark" placement="top">
                                    <li :class="{'active':listMode==='table'}"
                                        class="business_list_type_item"
                                        @click="handleClickBusinessListType('table')">
                                        <i class="iconfont icon-kanban"></i>
                                        <span>列表</span>
                                    </li>
                                </el-tooltip>
                                <el-tooltip content="切换为看板模式" effect="dark" placement="top">
                                    <li :class="{'active':listMode==='board'}"
                                        class="business_list_type_item"
                                        @click="handleClickBusinessListType('board')">
                                        <i class="iconfont icon-liebiao"></i>
                                        <span>看板</span>
                                    </li>
                                </el-tooltip>
                            </ul>
                            <el-button v-auth="'project.edit'"
                                       type="primary"
                                       @click="handleClickAddBusiness">新建商机
                            </el-button>
                        </div>
                    </div>
                    <div class="page_table_content">
                        <CustomVxeTable v-if="listMode==='table'"
                                        id="customTable1"
                                        ref="customTable"
                                        :class="{ 'custom-table': filterCount && !selectedList.length }"
                                        :customConfig="tableCustomConfig"
                                        :empty-render="{ name: 'NotData' }"
                                        :isShowToolBar="true"
                                        :pagination.sync="pagination"
                                        :reduceHeight="reduceHeight"
                                        :tableData="businessTableList"
                                        @handleCurrentChange="handleCurrentChange"
                                        @handleSizeChange="handleSizeChange"
                                        @selection-change="selectionChange">
                            <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                            <vxe-column v-for="field in formInfoList"
                                        :key="field.field_key"
                                        :align="field.align?'right':'left'"
                                        :field="field.field_key"
                                        :title="field.field_name"
                                        :fixed="field.field_key==='name'?'left':''"
                                        show-overflow
                                        width="150">
                                <template #default="{ row }">
                                    <div v-if="field.field_key==='name'"
                                         class="link-label"
                                         @click.stop="handleClickBusinessDetail(row)">
                                        <span v-text="row.name"></span>
                                    </div>
                                    <div v-else>
                                        <div v-if="field.field_type==='contact'">
                                            <div v-if="row[field.field_key].length">
                                                <div v-for="item in row[field.field_key]"
                                                     class="custom_contact_field_wrap">
                                                    <PersonnelCard :userId="item.id" v-if="item.id">
                                                        <template slot="container">
                                                            <img :src="item.avatar?item.avatar:defaultImg" alt=""
                                                                 class="avatar">
                                                            <span class="name" v-text="item.name"></span>
                                                        </template>
                                                    </PersonnelCard>
                                                </div>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='department'">
                                            <div v-if="row[field.field_key].length">
                                                <div v-for="item in row[field.field_key]">
                                                    <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                        <span v-text="item.department_name"></span>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='radio'">
                                    <span v-if="row[field.field_key]"
                                          :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                          v-text="row[field.field_key]"></span>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='checkbox'">
                                            <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              :class="{'is_tag_interaction':field.extend.tag_interaction}"
                                              v-text="item">
                                        </span>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='checkbox_user_tag'">
                                            <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span v-for="item in row[field.field_key]"
                                              class="is_tag_interaction"
                                              v-text="item.name">
                                        </span>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='image'">
                                            <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                                <el-image
                                                        :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                        :src="row[field.field_key][0].file_path"
                                                        fit="cover">
                                                </el-image>
                                                <el-popover :visible-arrow="false"
                                                            placement="bottom-start"
                                                            popper-class="table_custom_image_popover"
                                                            title=""
                                                            trigger="hover"
                                                            width="254">
                                                    <div slot="reference">
                                                <span v-if="row[field.field_key].length>1"
                                                      class="image_count"
                                                      v-text="`+${row[field.field_key].length-1}`"></span>
                                                    </div>
                                                    <ul class="image_list">
                                                        <li v-for="(img,img_index) in row[field.field_key]"
                                                            :key="img_index"
                                                            class="image_item">
                                                            <el-image
                                                                    :preview-src-list="row[field.field_key].map(img=>img.file_path)"
                                                                    :src="img.file_path"
                                                                    fit="cover">
                                                            </el-image>
                                                        </li>
                                                    </ul>
                                                </el-popover>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='file'">
                                            <div v-if="row[field.field_key].length"></div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='invoice'">
                                            <div v-if="row[field.field_key].length"></div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='relate_approve_form'"></div>
                                        <div v-else-if="field.field_type==='id_card'">
                                            <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                                <span v-text="row[field.field_key].text"></span>
                                                <el-popover placement="bottom"
                                                            popper-class="id_card_detail_popper"
                                                            trigger="click"
                                                            width="350">
                                                    <span slot="reference" class="handle_icon_wrap">
                                                         <i class="iconfont icon-shenfenzheng"></i>
                                                    </span>
                                                    <el-form size="small">
                                                        <el-form-item v-if="row[field.field_key].name" label="姓名"
                                                                      prop="name">
                                                            <span v-text="row[field.field_key].name"></span>
                                                        </el-form-item>
                                                        <el-form-item v-if="row[field.field_key].birthday"
                                                                      label="出生日期"
                                                                      prop="birthday">
                                                            <span v-text="row[field.field_key].birthday"></span>
                                                        </el-form-item>
                                                        <el-form-item v-if="row[field.field_key].address"
                                                                      label="家庭住址"
                                                                      prop="name">
                                                            <span v-text="row[field.field_key].address"></span>
                                                        </el-form-item>
                                                        <el-form-item label="身份证号" prop="text">
                                                            <span v-text="row[field.field_key].text"></span>
                                                        </el-form-item>
                                                    </el-form>
                                                    <img alt=""
                                                         class="ic_card_icon"
                                                         src="https://download.hecoos.com/enlightv/2024-48/2d35b952fcb868047612cca8bf82a615.png">
                                                </el-popover>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='paying_teller'">
                                            <div v-if="row[field.field_key]&&row[field.field_key].text"
                                                 class="custom_paying_teller_field_wrap">
                                                <span v-text="row[field.field_key].text"></span>
                                                <el-popover placement="bottom"
                                                            popper-class="paying_teller_detail_popper"
                                                            trigger="click"
                                                            width="350">
                                            <span slot="reference" class="handle_icon_wrap">
                                                 <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                                    <el-form class="custom_detail_form" label-position="top"
                                                             size="small">
                                                        <el-form-item label="账户类型" prop="account_type">
                                                            <span v-text="row[field.field_key].account_type===1?'个人账户':'对公账户'"></span>
                                                        </el-form-item>
                                                        <el-form-item label="户名" prop="account_name">
                                                            <span v-text="row[field.field_key].account_name"></span>
                                                        </el-form-item>
                                                        <el-form-item label="账号" prop="card_number">
                                                            <span v-text="row[field.field_key].card_number"></span>
                                                        </el-form-item>
                                                        <el-form-item label="所属银行" prop="bank_name">
                                                            <span v-text="row[field.field_key].bank_name"></span>
                                                        </el-form-item>
                                                        <el-form-item v-if="field.extend.bank_branch_is_show"
                                                                      label="银行支行"
                                                                      prop="bank_branch">
                                                            <span v-text="row[field.field_key].bank_branch"></span>
                                                        </el-form-item>
                                                    </el-form>
                                                </el-popover>
                                            </div>
                                            <span v-else>--</span>
                                        </div>
                                        <div v-else-if="field.field_type==='table'">
                                        </div>
                                        <div v-else-if="field.field_type==='radio_customer'">
                                            <span class="link-label"
                                                  @click="handleClickRelateCompanyDetail(row)"
                                                  v-text="row.customer_id.text"></span>
                                        </div>
                                        <div v-else-if="field.field_type==='customer_contact'">
                                            <span v-for="item in row.contact_id" v-text="item.name"></span>
                                        </div>
                                        <div v-else-if="field.field_type==='radio_project_stage'">
                                            <span v-text="row[field.field_key].text"></span>
                                        </div>
                                        <div v-else-if="field.field_type==='checkbox_approval'">
                                            <el-popover v-if="row[field.field_key].text&&row[field.field_key].text.length"
                                                        placement="top"
                                                        trigger="hover"
                                                        width="460">
                                                <el-link slot="reference"
                                                         :underline="false"
                                                         type="primary">
                                                    {{field.field_name }}（+{{ row[field.field_key].text.length }}）
                                                </el-link>
                                                <ul class="related_approval_list table_related_approval_list">
                                                    <li v-for="(item,index) in row[field.field_key].text"
                                                        class="related_approval_item">
                                                        <div class="flex_js_wrap">
                                                            <div class="related_approval_title flex_wrap">
                                                                <h4 v-text="item.approval_set_name"></h4>
                                                                <div :class="'relate_approve_status_' + item.status"
                                                                     class="relate_approve_status"
                                                                     v-text="item.status === 0 ? '审批中' : item.status === 1 ? '已通过' : item.status === 2 ? '已拒绝' : '已撤回'"></div>
                                                            </div>
                                                            <div class="flex_wrap">
                                                                <el-link :underline="false"
                                                                         type="primary"
                                                                         @click="handleClickRelatedApprovalDetail(item)">
                                                                    详情
                                                                </el-link>
                                                            </div>
                                                        </div>
                                                        <div class="flex_wrap approve_created_at">
                                                            <span v-text="item.user.name"></span>
                                                            <span>提交于</span>
                                                            <span v-text="item.created_at"></span>
                                                        </div>
                                                        <div v-if="item.overview_fields&&item.overview_fields.length"
                                                             class="overview_fields_wrap">
                                                            <div v-if="item.is_pack_up">
                                                                <OverviewFields
                                                                        :overviewFields="item.overview_fields"/>
                                                            </div>
                                                            <div class="ta_c">
                                                                <el-link :underline="false"
                                                                         type="primary"
                                                                         @click="handleApproveOverViewField(item)">
                                                                    {{
                                                                        item.is_pack_up ? '收起' : '展开'
                                                                    }}
                                                                    <i :class="item.is_pack_up?'icon-shangjiantou':'icon-xiajiantou'"
                                                                       class="iconfont"></i>
                                                                </el-link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </el-popover>
                                            <div v-else>--</div>
                                        </div>
                                        <div v-else-if="field.field_type==='system'">
                                            <el-link :underline="false"
                                                     type="primary"
                                                     :disabled="!row.has_quotation"
                                                     v-if="field.field_key==='relate_quotation'"
                                                     @click="handleClickViewTheQuotation(row)">查看报价单
                                            </el-link>
                                            <span v-if="field.field_key==='project_stage_start_at'"
                                                  v-text="row[field.field_key]"></span>
                                        </div>
                                        <span v-else
                                              v-text="row[field.field_key]?row[field.field_key]:'--'"></span>
                                    </div>
                                </template>
                            </vxe-column>
                            <vxe-column title="状态" width="100">
                                <template #default="{ row }">
                                    <span v-if="row.is_release === 0"
                                          class="approval_status approval_status_4">未发布</span>
                                    <span v-else :class="'approval_status_'+row.approval_status"
                                          class="approval_status"
                                          v-text="row.approval_status===0?'待审批':row.approval_status===1?'已通过':row.approval_status===2?'已驳回':row.approval_status===3?'已撤回':''"></span>
                                </template>
                            </vxe-column>
                            <vxe-column field="operate" fixed="right" width="90">
                                <template #header>
                                    <span>操作</span>
                                    <el-tooltip class="item"
                                                content="表头设置"
                                                effect="dark"
                                                placement="bottom-start">
                                        <i class="iconfont icon-biaotoushezhi table-header-icon"
                                           @click="handleClickCustom"></i>
                                    </el-tooltip>
                                </template>
                                <template #default="{ row }">
                                    <div class="table-operate-icon">
                                        <el-tooltip v-if="row['project.edit']" content="编辑"
                                                    effect="dark"
                                                    placement="top">
                                            <i class="iconfont icon-bianji" @click="handleClickEditBusiness(row)"></i>
                                        </el-tooltip>
                                        <el-dropdown v-if="row['project.edit']||hasDelPermission" placement="bottom-end"
                                                     trigger="click">
                                            <el-tooltip content="更多"
                                                        effect="dark"
                                                        placement="top">
                                                <i class="iconfont el-icon-more"></i>
                                            </el-tooltip>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item @click.native="handleClickAdvanceNextStage(row)"
                                                                  v-if="row.is_release===1&&row.approval_status===1&&row.project_stage.value>0&&row['project.edit']">
                                                    推进阶段
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                        v-if="row.is_release===1&&row.approval_status===1&&row['project.edit']"
                                                        @click.native="handleClickChangeThePerson([row.project_id])">
                                                    更换负责人
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                        v-if="row.is_release===1&&row.approval_status===1&&row['project.edit']"
                                                        @click.native="handleClickAddNewQuotation(row)">新增报价
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                        v-if="row.is_release===1&&row.approval_status===1&&row['project.edit']"
                                                        @click.native="handleClickAddMember([row.project_id])">
                                                    添加成员
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                        v-if="hasDelPermission"
                                                        @click.native="handleClickDelBusiness([row.project_id])">删除
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </template>
                            </vxe-column>
                        </CustomVxeTable>
                        <ul v-else class="business_board_list">
                            <li v-for="item in businessBoardList" :key="item.id" class="business_board_item">
                                <div class="business_stage_name_wrap">
                                    <span class="business_stage_name" v-text="item.name"></span>
                                    <span class="business_stage_count" v-text="`（${item.total}个）`"></span>
                                </div>
                                <ul :ref="`stage_data_list_`+item.id"
                                    class="business_stage_data_list"
                                    @wheel="handleStageListScroll(item)">
                                    <li v-for="child in item.data"
                                        @click="handleClickBusinessDetail(child)"
                                        class="business_stage_data_item">
                                        <div class="business_name_wrap flex_js_wrap">
                                            <div class="left_name_box flex_wrap">
                                                <i class="iconfont icon-shangji"></i>
                                                <span class="business_name" v-text="child.name"></span>
                                                <span v-if="child.status!==0"
                                                      :class="'business_status_name_'+child.status"
                                                      class="business_status_name"
                                                      v-text="child.status_name"></span>
                                            </div>
                                            <i class="el-icon-arrow-right"></i>
                                        </div>
                                        <div class="flex_wrap mb_8">
                                            <span class="form_item_label">客户：</span>
                                            <span class="form_item_value" v-text="child.customer_name"></span>
                                        </div>
                                        <div class="flex_wrap">
                                            <span class="form_item_label">负责人：</span>
                                            <PersonnelCard v-if="child.salesperson" :userId="child.salesperson">
                                                <template slot="container">
                                                    <div class="user-avatar-btn">
                                                        <img :src="child.salesperson_avatar?child.salesperson_avatar:defaultImg"
                                                             alt=""/>
                                                        <span v-text="child.salesperson_name"></span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </li>
                                    <li v-if="item.loading">数据加载中 <i class="el-icon-loading"></i></li>
                                </ul>
                            </li>
                            <li v-if="businessBoardList.length" class="last_empty_item">
                                <div class="top"></div>
                                <div class="bottom"></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <businessAdd v-if="addBusinessDialogVisible"
                             @refresh-list="getBusinessTableList"
                             :dialogVisible.sync="addBusinessDialogVisible"/>
                <businessEdit v-if="editBusinessDialogVisible"
                              :dialogVisible.sync="editBusinessDialogVisible"
                              :project_id="project_id"
                              @refresh-list="getBusinessTableList"/>
                <changeThePerson v-if="changeThePersonDialogVisible"
                                 :project_ids="project_ids"
                                 @refresh="getBusinessTableList"
                                 :dialogVisible.sync="changeThePersonDialogVisible"/>
                <addMember v-if="addMemberDialogVisible"
                           :project_ids="project_ids"
                           @refresh="getBusinessTableList"
                           :dialogVisible.sync="addMemberDialogVisible"/>
                <el-dialog v-if="stageTaskDialogVisible"
                           :before-close="handleClickStageTaskDialogCancel"
                           :close-on-click-modal="false"
                           :close-on-press-escape="false"
                           :visible.sync="stageTaskDialogVisible"
                           class="custom_form_dialog custom-form-dialog"
                           title="填写阶段任务"
                           width="560px">
                    <div class="custom_form_body">
                        <CustomFormPc ref="stage_task_form"
                                      :field_list="stageTaskFieldsList"
                                      :form_detail="stageTaskFieldsFormDetail"
                                      :is_form_module="true"
                                      :pk_id="currentProjectStageId"
                                      @submit-form="submitTaskFormData"/>
                    </div>
                    <div slot="footer">
                        <el-button size="small" @click="handleClickStageTaskDialogCancel">取消</el-button>
                        <el-button :disabled="btnDisabled"
                                   size="small"
                                   type="primary"
                                   @click="handleClickStageTaskDialogConfirm">
                            确定
                        </el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="报价单列表" name="quotation">
                <div class="el_tab_pane_wrap">
                    <div class="page-filter_wrap">
                        <div class="page-filter_wrap_left">
                            <el-input v-model="searchForm.keyword"
                                      class="filter-input"
                                      clearable
                                      placeholder="请输入您想搜索的内容"
                                      @clear="handleClickSearch"
                                      @blur="handleClickSearch"
                                      @keyup.enter.native="handleKeyupEnter">
                                <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                            </el-input>
                            <el-popover ref="quotationSearchPopover"
                                        placement="bottom-start"
                                        popper-class="filter_popper"
                                        trigger="click"
                                        width="500">
                                <div slot="reference" class="filter_popper_btn">
                                    <el-button class="custom_btn" size="small">
                                        <i class="iconfont icon-shaixuan"></i>
                                    </el-button>
                                </div>
                                <div class="advanced_filter_wrap">
                                    <div class="filter_title_wrap">
                                        <span>筛选</span>
                                        <div>
                                            <el-button size="mini" @click="handleClickClearCondition">清空筛选条件
                                            </el-button>
                                        </div>
                                    </div>
                                    <div class="filter_content_wrap">
                                        <ul class="advanced_filter_list">
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-input v-model="searchForm.quotation_status_name" disabled
                                                              size="small"></el-input>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-input v-model="searchForm.quotation_status_operator" disabled
                                                              size="small"></el-input>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-select v-model="searchForm.quotation_status"
                                                               placeholder="请选择报价状态"
                                                               size="small"
                                                               @change="handleQuotationFilterChange">
                                                        <el-option :value="1" label="审批中"></el-option>
                                                        <el-option :value="2" label="已拒绝"></el-option>
                                                        <el-option :value="3" label="已撤回"></el-option>
                                                        <el-option :value="4" label="报价中"></el-option>
                                                        <el-option :value="5" label="已失效"></el-option>
                                                        <el-option :value="6" label="已成单"></el-option>
                                                        <el-option :value="7" label="存在异议"></el-option>
                                                    </el-select>
                                                </div>
                                            </li>
                                            <li class="advanced_filter_item">
                                                <div class="field_select_wrap">
                                                    <el-input v-model="searchForm.quotation_at_name" disabled
                                                              size="small"></el-input>
                                                </div>
                                                <div class="operator_select_wrap">
                                                    <el-input v-model="searchForm.quotation_status_operator" disabled
                                                              size="small"></el-input>
                                                </div>
                                                <div class="field_value_form_wrap">
                                                    <el-date-picker v-model="searchForm.quotation_at"
                                                                    :editable="false"
                                                                    end-placeholder="结束日期"
                                                                    format="yyyy/MM/dd"
                                                                    range-separator="～"
                                                                    size="small"
                                                                    start-placeholder="开始日期"
                                                                    type="daterange"
                                                                    value-format="yyyy-MM-dd"
                                                                    @change="handleQuotationFilterChange">
                                                    </el-date-picker>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-popover>
                        </div>
                        <div class="page-filter_wrap_right">
                            <el-button v-auth="'project.quotation.edit'"
                                       type="primary"
                                       @click="handleClickAddQuotation">新增报价
                            </el-button>
                        </div>
                    </div>
                    <div class="page_table_content">
                        <ul v-infinite-scroll="scrollLoadQuotation" class="quotation_list">
                            <li v-for="item in quotationList" class="quotation_item">
                                <div :class="{'table_show':item.table_show}" class="quotation_item_header"
                                     @click="handleClickQuotationItem(item)">
                                    <i class="el-icon-caret-right"></i>
                                    <div class="quotation_name">
                                        <i class="iconfont icon-baojiadan"></i>
                                        <span v-text="item.project_name"></span>
                                    </div>
                                    <span class="line"></span>
                                    <span v-text="'报价' + item.quotation_count + '次'"></span>
                                </div>
                                <div v-if="item.table_show" class="quotation_item_content">
                                    <vxe-table :data="item.quotations" border min-height="85" round>
                                        <vxe-column field="quotation_num" title="报价编号">
                                            <template #default="{ row }">
                                                <el-link :underline="false" type="primary"
                                                         @click="handleClickQuotationDetail(row)"
                                                         v-text="row.quotation_num"></el-link>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="" title="报价人">
                                            <template #default="{ row }">
                                                <PersonnelCard v-if="row.quoter" :userId="row.quoter">
                                                    <template slot="container">
                                                        <div class="user-avatar-btn">
                                                            <img :src="row.quoter_avatar?row.quoter_avatar:defaultImg"
                                                                 alt=""
                                                                 class="avatar">
                                                            <span class="name" v-text="row.quoter_name"></span>
                                                        </div>
                                                    </template>
                                                </PersonnelCard>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="quotation_at" title="报价时间" width="163"></vxe-column>
                                        <vxe-column field="" title="查看明细" width="118">
                                            <template #default="{ row }">
                                                <el-link :underline="false"
                                                         type="primary">查看明细
                                                </el-link>
                                            </template>
                                        </vxe-column>
                                        <vxe-column align="right"
                                                    field="total_price"
                                                    title="报价总金额"
                                                    width="170">
                                            <template #default="{ row }">
                                                <span v-text="row.total_price.text"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column field="expiration_at" title="失效时间"></vxe-column>
                                        <vxe-column field="status_name" title="状态">
                                            <template #default="{ row }">
                                                <span :class="'status_icon_'+row.status" class="status_icon"></span>
                                                <span class="status_name" v-text="row.status_name"></span>
                                            </template>
                                        </vxe-column>
                                        <vxe-column title="操作" width="85">
                                            <template #default="{ row }">
                                                <el-tooltip v-if="row['project.quotation.edit']"
                                                            content="再次报价"
                                                            effect="dark"
                                                            placement="top">
                                                    <span class="handle_icon_wrap"
                                                          @click="handleClickQuotationAgain(row)">
                                                        <i class="iconfont icon-zaicitijiao"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span v-if="row['project.quotation.edit']" class="line"></span>
                                                <el-dropdown v-if="row['project.quotation.edit']"
                                                             placement="bottom-end"
                                                             trigger="click">
                                                    <el-tooltip content="更多" effect="dark" placement="top">
                                                            <span class="handle_icon_wrap">
                                                            <i class="iconfont icon-gengduo"></i>
                                                        </span>
                                                    </el-tooltip>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item v-if="row.approval_status===1"
                                                                          @click.native="handleClickRevokeQuotation(row)">
                                                            撤回
                                                        </el-dropdown-item>
                                                        <el-dropdown-item v-if="row.status===2||row.status===3"
                                                                          @click.native="handleClickDelQuotation(row)">
                                                            删除
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                                v-if="row.status===4||row.status===5||row.status===6||row.status===7"
                                                                @click.native="handleClickShareQuotation(row)">分享
                                                        </el-dropdown-item>
                                                        <el-dropdown-item v-if="row.status===4"
                                                                          v-auth="'order.edit'"
                                                                          permission_type="customer"
                                                                          route_name="Order"
                                                                          @click.native="handleClickCreateOrder(row)">
                                                            生成订单
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                                @click.native="handleClickPrintQuotation(row)">打印
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                                @click.native="handleClickDownloadQuotation(row)">下载
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </template>
                                        </vxe-column>
                                    </vxe-table>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <quotationTemplate v-if="addQuotationDialogVisible"
                           :dialogVisible.sync="addQuotationDialogVisible"/>
        <quotationShareDialog v-if="shareDialogVisible"
                              :dialogVisible.sync="shareDialogVisible"
                              :quotation_key="projectQuotationKey"
                              :quotation_title="projectQuotationTitle"/>
        <quotationDownloadDialog v-if="quotationDownloadDialog"
                                 :dialogVisible.sync="quotationDownloadDialog"
                                 :quotation_id="projectQuotationKey"/>
        <quotationPrintDialog v-if="quotationPrintDialog"
                              :dialogVisible.sync="quotationPrintDialog"
                              :quotation_id="projectQuotationKey"/>
        <OrderSubmitAgain v-if="createOrderDialogVisible"
                          :dialogVisible.sync="createOrderDialogVisible"
                          :project_quotation_id="project_quotation_id"/>
    </div>
</template>
<script>
import {pagination} from '@/mixins'
import CustomVxeTable from "@/components/pComponents/vxe-table";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import CustomFormSite from "@/components/pComponents/CustomFormSite";
import businessAdd from "./component/business_add";
import businessEdit from "./component/business_edit";
import quotationTemplate from "./component/quotation_template";
import changeThePerson from "./component/change_the_person";
import addMember from "./component/add_member";
import quotationShareDialog from "./component/quotation_share_dialog";
import quotationDownloadDialog from "./component/quotation_download_dialog";
import quotationPrintDialog from "./component/quotation_print_dialog";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import {EventBus} from '@/utils/eventBus';
import OrderSubmitAgain from "@/views/pc/Order/component/order_submit_again.vue";
import {
    getFormFields,
    projectDel,
    projectList,
    getProjectGroupAndStage,
    projectStageList,
    groupGetStageAndTask,
    getAutoSaveStagePushInfo,
    stagePush,
    projectQuotationList,
    projectQuotationDel,
    projectQuotationShare,
    cancelApproval,
} from "@/api";
import {tableDataFieldShow} from "@/utils";
import {mapGetters} from "vuex";
import OverviewFields from "@/components/pComponents/overviewFields.vue";

export default {
    name: "Business",
    mixins: [pagination],
    components: {
        OverviewFields,
        OrderSubmitAgain,
        CustomVxeTable,
        ListAdvancedFiltering,
        CustomFormSite,
        businessAdd,
        businessEdit,
        changeThePerson,
        addMember,
        PersonnelCard,
        quotationTemplate,
        CustomFormPc,
        quotationShareDialog,
        quotationDownloadDialog,
        quotationPrintDialog,
    },
    data() {
        return {
            searchForm: {
                keyword: '',
                project_group_id: '',
                project_stages: [],
                quotation_status: '',
                quotation_status_name: '报价状态',
                quotation_status_operator: '满足',
                quotation_at: [],
                quotation_at_name: '报价时间',
            },
            businessTableList: [],
            businessBoardList: [],
            loading: false,//加载动画
            tabActiveName: 'business', //quotation  business
            systemFilterFields: [],
            listMode: 'table', //board table
            filterCount: 0,
            businessGroupList: [],
            addBusinessDialogVisible: false,
            editBusinessDialogVisible: false,
            changeThePersonDialogVisible: false,
            addMemberDialogVisible: false,
            selectedList: [],
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return true
                },
                allowSort: true,
            },
            quotationList: [],
            quotationPagination: {
                pageSize: 15,
                total: 0,
                pageNum: 1,
            },
            addQuotationDialogVisible: false,
            formInfoList: [],
            defaultImg: require('@/assets/images/default.jpg'),
            custom_filter: {},
            project_id: 0,
            project_ids: [],
            stageTaskDialogVisible: false,
            stageTaskFieldsList: [],
            stageTaskFieldsFormDetail: {},
            currentProjectStageId: 0,
            btnDisabled: false,
            shareDialogVisible: false,
            quotationDownloadDialog: false,
            quotationPrintDialog: false,
            projectQuotationTitle: '',
            projectQuotationKey: '',
            createOrderDialogVisible: false,
            project_quotation_id: 0,
        }
    },
    created() {
        this._getFromFields()
        EventBus.$on('quotationUpdated', this.getOrderTableList);
    },
    computed: {
        reduceHeight() {
            return this.filterCount ? 200 : 210
        },
        ...mapGetters(['hasPermission']),
        hasDelPermission() {
            return this.hasPermission('project.del', 'customer', 'Project');
        },
    },
    mounted() {

    },
    methods: {
        // tab切换事件
        handleClickTab(tab) {
            this.searchForm.keyword = ''
            if (tab.name === 'quotation') {
                this.getQuotationList()
            }
        },

        //获取自定义字段列表
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'projects',
                filter_field_type: ''
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    this.getBusinessTableList()
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        //获取商机列表
        getBusinessTableList() {
            projectList({
                page: this.pagination.pageNum,
                size: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.businessTableList = data
                    this.pagination.total = total
                    tableDataFieldShow(this.formInfoList, this.businessTableList)
                    this.project_ids = []
                }
                this.loading = false
            })
        },

        // 搜索
        handleClickSearch() {
            if (this.tabActiveName === 'business') {
                if (this.listMode === 'table') {
                    this.getBusinessTableList()
                } else {
                    this.getBusinessBoardList()
                }
            } else if (this.tabActiveName === 'quotation') {

            }
        },

        //搜索框回车
        handleKeyupEnter() {
            this.$refs.search_input.blur()
        },

        // 获取筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            if (this.listMode === 'table') {
                this.getBusinessTableList()
            } else {
                this.getBusinessBoardList()
            }
        },

        //点击查看商机详情
        handleClickBusinessDetail({project_id, name}) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },

        //点击查看关联客户详情
        handleClickRelateCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id.value,
                    name: row.customer_id.text,
                },
            });
        },

        //新增商机事件
        handleClickAddBusiness() {
            this.addBusinessDialogVisible = true
        },

        //点击切换列表模式
        handleClickBusinessListType(mode) {
            this.listMode = mode
            if (mode === 'board' && this.businessGroupList.length === 0 && this.businessBoardList.length === 0) {
                this.getBusinessGroupList()
            }
        },

        //获取商机组列表
        getBusinessGroupList() {
            this.loading = true
            getProjectGroupAndStage({}).then(res => {
                if (res.code === 200) {
                    this.businessGroupList = res.data
                    if (this.businessGroupList.length) {
                        this.searchForm.project_group_id = this.businessGroupList[0].project_group_id
                        this.businessBoardList = this.businessGroupList[0].project_stages
                        this.searchForm.project_stages = this.businessGroupList[0].project_stages.map(item => item.id)
                        this.getBusinessBoardList()
                    }
                } else {
                    this.loading = false
                }
            })
        },

        //获取商机看板
        getBusinessBoardList(pageNum) {
            this.loading = true
            projectStageList({
                page: pageNum ? pageNum : 1,
                pageSize: 10,
                project_group_id: this.searchForm.project_group_id,
                project_stages: this.searchForm.project_stages,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter
            }).then(res => {
                if (res.code === 200) {
                    this.businessBoardList.forEach(item => {
                        const stage = res.data.find(stage => stage.project_stage === item.id)
                        item.data = stage.data || []
                        item.total = stage.total || 0
                        item.pageNum = 1
                        item.loading = false
                    })
                }
                this.loading = false
            })
        },

        //商机看板滚动事件
        handleStageListScroll(item) {
            if (item.loading) return false
            const container = this.$refs[`stage_data_list_` + item.id][0]
            if (container.scrollHeight === container.scrollTop + container.clientHeight) {
                if (item.data.length < item.total) {
                    item.loading = true
                    item.pageNum++
                    projectStageList({
                        page: item.pageNum,
                        pageSize: 10,
                        project_group_id: this.searchForm.project_group_id,
                        project_stage: item.id,
                        keyword: this.searchForm.keyword,
                        custom_filter: this.custom_filter
                    }).then(res => {
                        if (res.code === 200) {
                            this.$set(item, 'data', item.data.concat(res.data.data))
                            this.$nextTick(() => {
                                item.loading = false
                                this.$forceUpdate()
                            })
                        } else {
                            item.loading = false
                        }
                    })
                }
            }
        },

        //商机组切换事件
        handleProjectGroupChange(val) {
            const group = this.businessGroupList.find(item => item.project_group_id === val)
            this.businessBoardList = group.project_stages
            this.searchForm.project_stages = group.project_stages.map(item => item.id)
            this.getBusinessBoardList()
        },

        //点击查看报价单
        handleClickViewTheQuotation(row) {

        },

        //点击编辑商机
        handleClickEditBusiness(row) {
            this.project_id = row.project_id
            this.editBusinessDialogVisible = true
        },

        //点击推进阶段
        handleClickAdvanceNextStage(row) {
            groupGetStageAndTask({
                project_group_id: row.project_group_id
            }).then(res => {
                if (res.code === 200) {
                    const currentStage = res.data.find(item => item.project_stage_id === row.project_stage.value) || {}
                    if (currentStage && currentStage.sort === res.data.length) return this.$message.error('已经是最后一阶段，无法推进')
                    this.currentProjectStageId = currentStage.project_stage_id
                    this.project_id = row.project_id
                    this.nextStageId = res.data[currentStage.sort].project_stage_id
                    if (currentStage.tasks && currentStage.tasks.length) {
                        const field = {
                            field_form: "projects",
                            field_key: currentStage.project_stage_id,
                            field_name: currentStage.name + '任务',
                            field_type: "form_module",
                            extend: {
                                is_form_show: true
                            },
                            sort: currentStage.sort,
                            _child: currentStage.tasks
                        }
                        this.stageTaskFieldsList = [field]
                        if (this.stageTaskFieldsList.length) {
                            getAutoSaveStagePushInfo({
                                project_id: row.project_id,
                                project_stage: currentStage.project_stage_id,
                            }).then(res => {
                                if (res.code === 200) {
                                    field._child.forEach(child => {
                                        if (row.hasOwnProperty(child.field_key)) {
                                            this.$set(this.stageTaskFieldsFormDetail, child.field_key, row[child.field_key])
                                        }
                                        if (res.data && res.data.hasOwnProperty(child.field_key)) {
                                            const field_value = res.data[child.field_key]
                                            if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' && field_value.value !== undefined && field_value.value.length !== 0))) {
                                                this.$set(this.stageTaskFieldsFormDetail, child.field_key, field_value)
                                            }
                                        }
                                    })
                                    this.stageTaskDialogVisible = true
                                }
                            })
                        }
                    } else {
                        stagePush({
                            project_id: this.project_id,
                            project_stage: this.nextStageId,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message.success('推进成功')
                                this.getBusinessTableList()
                                this.handleClickStageTaskDialogCancel()
                            }
                        })
                    }
                }
                this.loading = false
            })
        },

        //商机推进弹窗取消
        handleClickStageTaskDialogCancel() {
            this.stageTaskDialogVisible = false
            this.nextStageId = 0
            this.stageTaskFieldsList = []
            this.stageTaskFieldsFormDetail = {}
        },

        //商机推进弹窗确定
        handleClickStageTaskDialogConfirm() {
            this.$refs.stage_task_form.handleClickPublish()
        },

        submitTaskFormData(data) {
            stagePush({
                project_id: this.project_id,
                project_stage: this.nextStageId,
                ...data
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('推进成功')
                    this.getBusinessTableList()
                    this.handleClickStageTaskDialogCancel()
                }
            })
        },

        //点击更换负责人
        handleClickChangeThePerson(ids) {
            this.project_ids = ids
            this.changeThePersonDialogVisible = true
        },

        //点击新增报价
        handleClickAddNewQuotation(row) {
            this.addQuotationDialogVisible = true
        },

        //点击添加成员
        handleClickAddMember(ids) {
            this.project_ids = ids
            this.addMemberDialogVisible = true
        },

        //点击删除商机
        handleClickDelBusiness(ids) {
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectDel({
                    project_id: ids
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getBusinessTableList()
                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },

        // 列表选择事件
        selectionChange(ids) {
            this.selectedList = ids.map(item => item.project_id);
        },

        // 清空复选框选中
        handleRemoveCheckbox() {
            this.selectedList = [];
            this.$refs.customTable.removeCheckboxRow();
        },

        // 表头配置
        handleClickCustom() {
            this.$refs.customTable.handleOpenCustomShow();
        },

        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getBusinessTableList();
        },

        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getBusinessTableList();
        },

        //获取商机报价单列表
        getQuotationList() {
            projectQuotationList({
                keyword: this.searchForm.keyword,
                quotation_status: this.searchForm.quotation_status,
                quotation_at: this.searchForm.quotation_at ? this.searchForm.quotation_at.join(' - ') : '',
                page: this.quotationPagination.pageNum,
                pageSize: this.quotationPagination.pageSize,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total, permission, primaryKey} = res.data
                    if (data.length) {
                        data.forEach(item => {
                            if (item.quotations.length) {
                                item.quotations.forEach(quotation => {
                                    let auth = permission[quotation[primaryKey]]
                                    for (let authKey in auth) {
                                        quotation[authKey] = auth[authKey]
                                    }
                                })
                            }
                        })
                    }
                    this.quotationList = this.quotationList.concat(data)
                    this.quotationPagination.total = total
                }
            })
        },

        scrollLoadQuotation() {
            if (this.quotationPagination.pageNum * this.quotationPagination.pageSize < this.quotationPagination.total) {
                this.quotationPagination.pageNum++
                this.getQuotationList()
            }
        },

        handleQuotationFilterChange() {
            this.$refs.quotationSearchPopover.doClose()
            this.pagination.pageNum = 1
            this.getQuotationList()
        },

        //清空筛选条件
        handleClickClearCondition() {
            this.searchForm.quotation_at = []
            this.searchForm.quotation_status = ''
            this.getQuotationList()
        },

        //点击新增报价单
        handleClickAddQuotation() {
            this.addQuotationDialogVisible = true
        },

        // 点击报价单
        handleClickQuotationItem(item) {
            if (item.hasOwnProperty('table_show')) {
                item.table_show = !item.table_show
            } else {
                this.$set(item, 'table_show', true)
            }
        },

        // 点击查看报价单详情
        handleClickQuotationDetail(row) {
            this.$router.push({
                name: "QuotationDetails",
                params: {
                    isPush: true,
                },
                query: {
                    project_quotation_id: row.project_quotation_id,
                    name: row.title,
                },
            })
        },

        //再次报价
        handleClickQuotationAgain(row) {
            this.$router.push({
                name: 'QuotationAdd',
                query: {
                    project_quotation_tmpl_form: row.project_quotation_tmpl_form,
                    project_quotation_id: row.project_quotation_id,
                },
            })
        },

        //撤回报价单
        handleClickRevokeQuotation(item) {
            this.$msgbox({
                title: '确认撤回吗？',
                message: '撤回后不可恢复，请谨慎操作！',
                confirmButtonText: '撤回',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                cancelApproval({
                    approval_id: item.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('撤回成功')
                        this.getQuotationList()
                    }
                })
            })
        },

        //删除报价单
        handleClickDelQuotation(item) {
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectQuotationDel({
                    project_quotation_id: item.project_quotation_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.getQuotationList()
                    }
                })
            })
        },

        //分享报价单
        handleClickShareQuotation(item) {
            this.projectQuotationTitle = item.title
            projectQuotationShare({
                project_quotation_id: item.project_quotation_id
            }).then(res => {
                if (res.code === 200) {
                    this.projectQuotationKey = res.data.key
                    this.shareDialogVisible = true
                }
            })
        },

        //生成订单
        handleClickCreateOrder(item) {
            this.project_quotation_id = item.project_quotation_id
            this.createOrderDialogVisible = true
        },

        //打印报价单
        handleClickPrintQuotation(item) {
            this.projectQuotationKey = item.project_quotation_id
            this.quotationPrintDialog = true
        },

        //下载报价单
        handleClickDownloadQuotation(item) {
            this.projectQuotationKey = item.project_quotation_id
            this.quotationDownloadDialog = true
        },

        //关联审批单详情
        handleClickRelatedApprovalDetail(item) {
            this.$showApprovalDetail({
                approval_id: item.id,
            }).then((res) => {

            });
        },
    },
    beforeDestroy() {
        EventBus.$off('quotationUpdated', this.getOrderTableList);
    },
}
</script>
<style lang="scss" scoped>
.business_list_type_list {
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 4px;
    height: 32px;
    margin-right: 12px;

    .business_list_type_item {
        cursor: pointer;
        text-align: center;
        line-height: 24px;
        padding: 4px 12px;
        box-sizing: border-box;
        height: 32px;
        border: 1px solid #D9D9D9;

        .iconfont {
            font-size: 14px;
            margin-right: 4px;
        }

        &.active {
            background-color: rgba(25, 144, 255, 0.16);
            color: #2990ff;
            border-radius: 4px;
            border-color: #2990ff;
        }
    }
}

.business_board_list {
    width: 100%;
    height: 100%;
    display: flex;
    border: 1px solid #E8E8E8;
    border-radius: 6px;
    overflow-x: auto;
    overflow-y: hidden;

    .business_board_item {
        min-width: 256px;
        height: 100%;

        &:nth-last-child(2) {
            .business_stage_name_wrap {
                &::after {
                    display: none;
                }

                &::before {
                    display: none;
                }
            }

            .business_stage_data_list {
                border-right: none;
            }
        }

        .business_stage_name_wrap {
            text-align: center;
            background-color: #EDF0F4;
            color: #333333;
            line-height: 22px;
            padding: 8px 0;
            position: relative;

            &::after {
                width: 12px;
                height: 38px;
                content: '';
                background-color: #E8E8E8;
                position: absolute;
                right: -11px;
                top: 0;
                z-index: 10;
                clip-path: polygon(0 0, 0 0, 100% 50%, 0 100%, 0 0);
            }

            &::before {
                width: 12px;
                height: 38px;
                content: '';
                background-color: #EDF0F4;
                position: absolute;
                right: -9px;
                top: 0;
                z-index: 11;
                clip-path: polygon(0 0, 0 0, 100% 50%, 0 100%, 0 0);
            }
        }

        .business_stage_data_list {
            height: calc(100% - 44px);
            overflow-y: auto;
            overflow-x: hidden;
            border-right: 1px solid #E8E8E8;
            padding: 12px 8px;

            .business_stage_data_item {
                border-radius: 6px;
                border: 1px solid #E8E8E8;
                margin-bottom: 12px;
                padding: 12px;
                cursor: pointer;
                transition: all 0.3s;

                &:hover {
                    box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.08);
                }

                &:last-child {
                    margin-bottom: 0;
                }

                .flex_js_wrap {
                    margin-bottom: 8px;
                }

                .business_name_wrap {
                    width: 100%;
                    overflow: hidden;
                    gap: 8px;

                    .left_name_box {
                        flex: 1;
                        width: calc(100% - 20px);

                        .business_name {
                            font-weight: 700;
                            line-height: 22px;
                            flex: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            display: inline-block;
                        }

                        .business_status_name {
                            display: inline-block;
                            vertical-align: middle;
                            padding: 0 8px;
                            border-radius: 4px;
                            line-height: 22px;

                            &.business_status_name_1 {
                                background-color: rgba(240, 170, 50, 0.1);
                                color: #F0AA32;
                            }

                            &.business_status_name_2 {
                                background-color: rgba(191, 191, 191, 0.1);
                                color: #BFBFBF;
                            }

                            &.business_status_name_3 {
                                background-color: rgba(228, 65, 68, 0.1);
                                color: #E44144;
                            }

                            &.business_status_name_4 {
                                background-color: rgba(191, 191, 191, 0.1);
                                color: #BFBFBF;
                            }
                        }
                    }
                }

                .el-icon-arrow-right {
                    font-size: 12px;
                    color: #666666;
                    vertical-align: middle;
                }

                .form_item_label {
                    font-size: 12px;
                    line-height: 18px;
                    color: #999999;
                }

                .form_item_value {
                    font-size: 12px;
                    line-height: 18px;
                    color: #666666;
                }
            }
        }
    }

    .last_empty_item {
        position: sticky;
        right: 0;
        z-index: 50;

        .top {
            width: 8px;
            height: 38px;
            background-color: #EDF0F4;
            box-shadow: -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
            border-right: 1px solid #E8E8E8;
            border-bottom: 1px solid #E8E8E8;
        }

        .bottom {
            width: 8px;
            height: calc(100% - 38px);
            border-radius: 0 0 5px 0;
            background: #FFFFFF;
            box-shadow: -2px 0px 4px -2px rgba(0, 0, 0, 0.08);
            border-right: 1px solid #E8E8E8;
            border-bottom: 1px solid #E8E8E8;
        }
    }
}

.page_table_content {
    margin-top: 16px;
    height: calc(100% - 48px);

    .quotation_list {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;

        .quotation_item {
            border-radius: 6px;
            border: 1px solid #E8E8E8;
            margin-bottom: 8px;

            .quotation_item_header {
                padding: 12px 20px;
                display: flex;
                align-items: center;
                cursor: pointer;

                &.table_show {
                    .el-icon-caret-right {
                        transform: rotate(90deg);
                    }
                }

                &:hover {
                    background-color: rgba(0, 0, 0, 0.04);
                }

                .el-icon-caret-right {
                    margin-right: 16px;
                    transition: all 0.3s;
                }

                .quotation_name {
                    line-height: 22px;
                    color: #666666;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .relate_company {
                    line-height: 22px;
                    color: #2990FF;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    cursor: pointer;
                }

                .business_name {
                    line-height: 22px;
                    color: #2990FF;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    cursor: pointer;
                }
            }

            .quotation_item_content {
                padding: 0 12px 12px;

                .status_icon {
                    width: 6px;
                    height: 6px;
                    opacity: 1;
                    border-radius: 50%;
                    margin-right: 4px;
                    display: inline-block;
                    vertical-align: middle;

                    &.status_icon_1 {
                        background: #F0AA32;
                    }

                    &.status_icon_2 {
                        background: #E44144;
                    }

                    &.status_icon_3 {
                        background: #BFBFBF;
                    }

                    &.status_icon_4 {
                        background: #F0AA32;
                    }

                    &.status_icon_5 {
                        background: #BFBFBF;
                    }

                    &.status_icon_6 {
                        background: #5AB333;
                    }

                    &.status_icon_7 {
                        background: #E44144;
                    }
                }

                .status_name {
                    vertical-align: middle;
                }
            }
        }
    }
}

.approval_status {
    color: #666666;
    vertical-align: middle;
    margin-left: 4px;

    &::before {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-right: 4px;
    }

    &.approval_status_0::before {
        background: #F0AA32;
    }

    &.approval_status_1::before {
        background: #5AB333;
    }

    &.approval_status_2::before {
        background: #E44144;
    }

    &.approval_status_3::before {
        background: #BFBFBF;
    }

    &.approval_status_4::before {
        background: #999999;
    }
}
</style>

